export default class CustomErrors {
  static SESSION_ERROR =
    "Sorry, we were unable to process your request. It might be due to a problem with your internet connection or our server. Please check your connection and try again. If the problem persists, please try again later.";

  static USER_NOT_FOUND = "Sorry! User Not Found! Please Check the Credentials!";
  static INCORRECT_CREDENTIALS="Oops! Username/Password is incorrect!";
}
